import { post } from "../axiosUitils";

const baseUrl = "/auth/verify-email"; // Replace with your actual API endpoint
class EmailSendOtpService {
  emailSendOtp = async (payload: { mail: string }): Promise<any> => {
    try {
      const response = await post<any>(`${baseUrl}/send-otp/`, payload);
      return response;
    } catch (error) {
      console.error("Error in email send OTP:", error);
      throw error;
    }
  };
  emailVerifyOtp = async (payload: {
    mail: string;
    otp: string;
    code_reference: string;
  }): Promise<any> => {
    try {
      const response = await post<any>(`${baseUrl}/verify-otp/`, payload);
      return response;
    } catch (error) {
      console.error("Error in email verify OTP:", error);
      throw error;
    }
  };
  emailResendOtp = async (payload: {
    code_reference: string;
  }): Promise<any> => {
    try {
      const response = await post<any>(`${baseUrl}/resend-otp/`, payload);
      return response;
    } catch (error) {
      console.error("Error in email resend OTP:", error);
      throw error;
    }
  };
}

const instance = new EmailSendOtpService();
export default instance;
